module.exports = __webpack_public_path__ + "static/CRMSap-909b1feaf14481437fcd017ba9665cc1.svg";